import {
  InternalApiScenario,
  InternalApiScenarioContentTestResultInformation,
  InternalApiScenarioEntityType,
  InternalApiScenarioTypeV2,
} from '../../../api-internal';
import dayjs from 'dayjs';
import { pluralize } from '../../../common/helper';
import React from 'react';
import { SalvDataTag, SalvFieldHeader, Size } from '@salvapp/ui-components';
import InternalLink from '../../../common/InternalLink';
import { generatePath } from 'react-router';
import { InternalNavigation } from '../../../navigation/helper';

export interface TestRunResultsProps {
  testResult: InternalApiScenarioContentTestResultInformation;
  scenario: InternalApiScenario;
}

export const TestRunResults = ({ testResult, scenario }: TestRunResultsProps) => {
  const isPersonEntity =
    scenario?.type === InternalApiScenarioTypeV2.PERIODIC ||
    scenario?.entityType == InternalApiScenarioEntityType.PERSON;

  return (
    <div className='m-y-24'>
      <SalvFieldHeader label='Results' size={Size.MEDIUM} />

      {testResult.runs.map((run, index) => (
        <div key={index} className='scenario-card'>
          <div className='header'>SCENARIO TEST RUN {run.time && dayjs(run.time).format('DD.MM.YYYY')}</div>

          <div className='content'>
            <div className='suppression-interval-results'>
              {run.alertingIntervals
                ?.sort((a, b) => a.alertingInterval - b.alertingInterval)
                .map((alertingInterval, intervalIndex) => {
                  const entityLabel = isPersonEntity
                    ? pluralize(alertingInterval.total || 0, 'person', 'persons', false)
                    : pluralize(alertingInterval.total || 0, 'transaction', 'transactions', false);

                  return (
                    <div key={intervalIndex}>
                      <div className='text-s'>
                        {alertingInterval.alertingInterval === 0
                          ? 'No alert suppression'
                          : `"${alertingInterval.alertingInterval} day"`}{' '}
                        interval matched{' '}
                        <b>
                          {alertingInterval.total} {entityLabel}
                        </b>
                      </div>
                      {!!alertingInterval.matches.length && (
                        <div>
                          <div className='text-strong-s m-y-8'>Sample {entityLabel}</div>
                          <div style={{ display: 'flex', gap: '8px', flexWrap: 'wrap' }}>
                            {alertingInterval.matches.map((match) => {
                              return (
                                <SalvDataTag
                                  key={match.entityId}
                                  value={
                                    <InternalLink
                                      title={match.entityId}
                                      link={generatePath(
                                        isPersonEntity ? InternalNavigation.person : InternalNavigation.transaction,
                                        { id: match.entityId! }
                                      )}
                                    />
                                  }
                                />
                              );
                            })}
                          </div>
                        </div>
                      )}
                    </div>
                  );
                })}
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};
